'use strict';

angular.module('mobile-apps')
	.directive('inputLanguage',['RtlLanguages', function(RtlLanguages) {
		return {
			restrict: 'A',
			scope:
			{
				language : '@'
			},
			link: function (scope, elem, attrs) {

				// Get the languages which should be displayed rtl
				var rtlLanguages = [];
				RtlLanguages.get(function success (response) {
					rtlLanguages.push.apply(rtlLanguages, response);
					setLanguageSettings();
				});


				function setLanguageSettings() {
					if (rtlLanguages.indexOf(scope.language) !== -1) {
						elem.addClass('rtl-language');
					} else {
						elem.removeClass('rtl-language');
					}
				}

				scope.$watch('language', function() {
					setLanguageSettings();
				});
			}
		};
	}]);


